const originForRelativeUrls = () =>
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost'

export function appendPreservedParams(url, paramsString) {
  if (!paramsString) return url

  try {
    const urlObj = new URL(url, originForRelativeUrls())
    new URLSearchParams(paramsString).forEach((value, key) => {
      if (!urlObj.searchParams.has(key)) {
        urlObj.searchParams.set(key, value)
      }
    })
    return urlObj.toString()
  } catch {
    const separator = url.includes('?') ? '&' : '?'
    const cleanParams = paramsString.startsWith('?')
      ? paramsString.slice(1)
      : paramsString
    return `${url}${separator}${cleanParams}`
  }
}

export function buildInternalHref(to, currentSearchParams, newParams = {}) {
  const hashIndex = to.indexOf('#')
  const hash = hashIndex >= 0 ? to.slice(hashIndex) : ''
  const pathAndQuery = hashIndex >= 0 ? to.slice(0, hashIndex) : to
  const queryIndex = pathAndQuery.indexOf('?')
  const pathname =
    queryIndex >= 0 ? pathAndQuery.slice(0, queryIndex) : pathAndQuery
  const existingQuery =
    queryIndex >= 0 ? pathAndQuery.slice(queryIndex + 1) : ''

  const params = new URLSearchParams()
  currentSearchParams.forEach((value, key) => params.set(key, value))
  new URLSearchParams(existingQuery).forEach((value, key) => {
    params.set(key, value)
  })
  Object.entries(newParams).forEach(([key, value]) => {
    params.set(key, value)
  })

  const queryString = params.toString()
  return `${pathname}${queryString ? `?${queryString}` : ''}${hash}`
}
